enum SearchParameters {
  ACTION = 'action',
  APPOINTMENT_ID = 'appointment_id',
  APPOINTMENT_TYPE = 'appointment_type',
  DEBUG = 'debug',
  AUTH_CONNECTION = 'authConnection',
  CUSTOMER_GID = 'customer_gid',
  COUNTRY = 'country',
  DELIVERY_MODEL = 'delivery_model',
  ID = 'id',
  IFRAME = 'iframe', // Whether or not this client request is iframed
  INSURANCE_COMPANY = 'insurance_company',
  JOURNEY = 'journey',
  LEAD_GID = 'lead_gid',
  LEAD_SALESFORCE_ID = 'leadSalesforceId',
  OPPORTUNITY_GID = 'opportunity_gid',
  PREVIEW = 'preview',
  RESOURCE_GID = 'resource_gid',
  RESOURCE_ID = 'resource_id',
  SCHEDULING_MODE = 'mode',
  SHOP_GID = 'shop_gid',
  SHOP_ID = 'shop_id',
  USE_CACHE = 'use_cache',
  /**
   * Used to restrict provider recommendations to a specific shop
   *
   * This parameter is set by salesforce and forwarded to the provider
   * recommendation service to trigger shop-specific filtering for network shops
   * in Germany.
   */
  RESTRICT_TO_SHOP = 'restrict_to_shop',
  SOLUTION = 'solution',
  START_DATE = 'start_date',
  START_TIME = 'start_time',
  TIMEZONE = 'time_zone',
  UTM_SOURCE = 'utm_source', // Used to track external clients linking to our system
}

export { SearchParameters }
